import ComponentHeader from '@atoms/ComponentHeader/ComponentHeader';
import { IImageWithProductFeature } from '@models/IImageWithProductFeature';
import ImageLightBox from '@molecules/ImageLightBox/ImageLightBox';
import ProductCard from '@molecules/ProductCard/ProductCard';
import useMediaQuery from '@utils/hooks/useMediaQuery';
import useResizeObserver from '@utils/hooks/useResizeObserver';
import classNames from 'classnames';

const ImageWithProductFeature = ({
  image,
  product,
  title,
  body,
  cta,
}: IImageWithProductFeature) => {
  const isMobile = useMediaQuery(1024);
  const isPortrait = image?.image?.desktop
    ? image.image.desktop.height > image.image.desktop.width
    : false;
  const isComponentHeaderDisplayed = !isPortrait && (title || body || cta?.url);
  const [imageDescriptionRef, { height: imageDescriptionHeight }] =
    useResizeObserver();

  return (
    <section className="component-padding bg-white text-black-100 dark:bg-black-100 dark:text-white">
      {isComponentHeaderDisplayed && (
        <ComponentHeader
          cta={cta}
          title={title}
          subtitle={body}
          hasTextMaxWidth
        />
      )}

      <div
        className={classNames(
          'container grid grid-cols-1 gap-x-4 lg:grid-cols-12',
          { 'mt-10': isComponentHeaderDisplayed }
        )}
      >
        <div
          className={classNames(
            'mb-8 flex flex-col items-center justify-center lg:mb-0',
            isPortrait
              ? 'lg:col-span-5 lg:col-start-2'
              : 'lg:col-span-7 xl:col-span-8'
          )}
        >
          {image && (
            <div className="relative w-full">
              <ImageLightBox
                {...image}
                contentIds={
                  image.meta?.contentLink
                    ? [image.meta.contentLink as string]
                    : []
                }
                imageClasses="w-full h-full"
              />
              {image.description && (
                <div
                  ref={imageDescriptionRef}
                  className="body-four pt-4 lg:mb-0 dark:text-white"
                  dangerouslySetInnerHTML={{ __html: image.description }}
                />
              )}
            </div>
          )}
        </div>

        <div
          style={{
            paddingBottom:
              isMobile || !imageDescriptionHeight
                ? 0
                : imageDescriptionHeight + 16,
          }}
          className={classNames(
            'flex items-center justify-center lg:col-span-5 xl:col-span-4',
            isPortrait && 'lg:col-start-8 xl:col-start-8'
          )}
        >
          <div
            className={classNames(
              isPortrait ? 'min-h-[69%]' : 'h-full',
              'flex w-full'
            )}
          >
            {product && (
              <ProductCard classes={isPortrait ? 'h-auto' : ''} {...product} />
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ImageWithProductFeature;
